export async function init () {
  const lastShareUrlSeen = localStorage.getItem('lastShareUrlSeen')

  if (lastShareUrlSeen) {
    localStorage.removeItem('lastShareUrlSeen')
  }

  window.location.href = lastShareUrlSeen || process.env.PREVIEW_URL
}
